<p-toast></p-toast>
<app-training-plan-panel-list 
  [puid]="null" 
  [enableSelection]="false" 
  [enableShowAll]="true">
</app-training-plan-panel-list>
